// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import FieldDefinition from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import XngZone from "@west/App/Components/Common/XngZone";
import { XNGAGE_CUSTOM_WIDGET } from "@west/XDL/constants";
import { xScreen } from "@west/XDL/Utilities";
import React, { FC } from "react";
import { css } from "styled-components";

interface BrandDetailsLayoutStyles {
    container?: InjectableCss;
    leftSection?: InjectableCss;
    rightSection?: InjectableCss;
}

export const brandDetailsLayoutStyles: BrandDetailsLayoutStyles = {
    container: {
        css: css`
            gap: 62px;
            width: 100%;
            display: flex;
            ${xScreen("lte", "md")} {
                flex-direction: column;
                gap: 20px;
                & > div {
                    width: 100%;
                }
            }
        `,
    },
    leftSection: {
        css: css`
            height: fit-content;
            width: 268px;
        `,
    },
    rightSection: {
        css: css`
            width: calc(100% - 268px - 62px);
        `,
    },
};

const styles = brandDetailsLayoutStyles;
const BrandDetailsLayout: FC<WidgetProps> = ({ id }) => {
    return (
        <StyledWrapper {...styles.container} data-test-selector="brandDeatils-layout-widget">
            <StyledWrapper {...styles.leftSection}>
                <XngZone contentId={id} zoneName="Content01" />
            </StyledWrapper>
            <StyledWrapper {...styles.rightSection}>
                <XngZone contentId={id} zoneName="Content02" />
            </StyledWrapper>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule<FieldDefinition> = {
    component: BrandDetailsLayout,
    definition: {
        group: XNGAGE_CUSTOM_WIDGET,
        displayName: "Brand Details Layout",
        allowedContexts: ["BrandDetailsPage"],
    },
};

export default widgetModule;
